import { api } from '../../core/network/api';

export type ChatChannel = 'global';

export interface ChatMessage {
  id: string;
  senderId: string;
  senderUsername: string | null;
  channel: ChatChannel;
  content: string;
  createdAt: string;
  isYou: boolean;
}

/** GET /api/chat/:channel — history, oldest-first. */
export const fetchChatHistory = (channel: ChatChannel, limit = 50) =>
  api.get<ChatMessage[]>(`/chat/${channel}?limit=${limit}`);

/** POST /api/chat — send a message (core rate-limits ~1 / 2s). */
export const sendChatMessage = (channel: ChatChannel, content: string) =>
  api.post<ChatMessage>('/chat', { channel, content });
